module.exports = __webpack_public_path__ + "static/media/Muvi_Logo_Blue_White.5e877fb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Muvi_Logo_Blue_White.svg
// module id = 322
// module chunks = 0